import {
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Typography,
} from "antd";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const RequesterAddressFields = ({ getChildData, validationRules, form }) => {
  const { t } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  return (
    <>
      <Col xs={24} md={12}>
        <Form.Item
          className="font-medium"
          label={t("singleRequest:recipient_name_organization")}
          onChange={(e) =>
            callparent(e.target.value, "RecordMethodReleaseName")
          }
          name="RecordMethodReleaseName"
          rules={[
            {
              required: true,
              max: 50,
              message: t(
                "singleRequest:please_enter_recipient_name_organization",
              ),
            },
          ]}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
     
      <Col xs={24} md={12}>
        <Form.Item
          className="font-medium"
          name="recipientAddress1"
          label={t("bulkRequest:address_line_1")}
          onChange={(e) => callparent(e.target.value, "recipientAddress1")}
          rules={validationRules.address1}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          className="font-medium"
          name="recipientAddress2"
          onChange={(e) => callparent(e.target.value, "recipientAddress2")}
          label={t("bulkRequest:address_line_2")}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="recipientCity"
          label={t("bulkRequest:city")}
          onChange={(e) => callparent(e.target.value, "recipientCity")}
          rules={validationRules.city}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="recipientState"
          label={t("bulkRequest:state")}
          onChange={(e) => callparent(e.target.value, "recipientState")}
          rules={validationRules.state}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="recipientZipCode"
          label={t("bulkRequest:zip_code")}
          onChange={(e) => callparent(e.target.value, "recipientZipCode")}
          required
          rules={validationRules.zipCode}
        >
          <Input maxLength={8} />
        </Form.Item>
      </Col>
    </>
  );
};

const RecordRelease = ({ getChildData, singleRequestData, form }) => {
  const { t } = useTranslation();

  const onChange = (e) => {
    callparent(e.target.value, "RecordMethod");
  };

  const callparent = (value, name) => {
    getChildData(value, name);
  };

  useEffect(() => {
    if (singleRequestData.RecordMethod === "mail") {
      form.setFieldsValue({
        RecordMethodReleaseName: singleRequestData.RequesterName,
        recipientAddress1: singleRequestData.RequesterAddLine1,
        recipientAddress2: singleRequestData.RequesterAddLine2,
        recipientCity: singleRequestData.RequesterCity,
        recipientState: singleRequestData.RequesterState,
        recipientZipCode: singleRequestData.RequesterZipCode,
      });
    }
  }, [singleRequestData.RecordMethod]);

  useEffect(() => {
    if (singleRequestData.useRequesterInformation)
      form.setFieldsValue({
        rnameorganization: singleRequestData.RequesterName,
        rphone: singleRequestData.RequesterPhoneNumber,
        remail: singleRequestData.RequesterEmail,
        // rfax: singleRequestData.RequesterFaxNumber,
      });
    else
      form.setFieldsValue({
        rnameorganization: singleRequestData.RecordName,
        rphone: singleRequestData.RecordPhoneNumber,
        remail: singleRequestData.RecordEmail,
        rfax: singleRequestData.RecordFaxNumber,
      });
  }, [singleRequestData.useRequesterInformation]);

  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(t("singleRequest:please_enter_a_valid_phone_number")),
    );
  };

  const validationRules = useMemo(
    () => ({
      address1: [
        {
          required: true,
          max: 150,
          message: t("singleRequest:please_enter_address"),
        },
      ],
      city: [
        {
          required: true,
          max: 50,
          message: t("singleRequest:please_enter_city_name"),
        },
      ],
      state: [
        {
          required: true,
          max: 50,
          message: t("singleRequest:please_enter_state_name"),
        },
      ],
      zipCode: [
        {
          max: 8,
          required: true,
          message: t("singleRequest:please_enter_zip_code"),
        },
        {
          pattern: /^[0-9]+$/,
          message: t("singleRequest:zip_code_must_be_numeric"),
        },
        {
          min: 5,
          message: t("singleRequest:zip_code_must_be_at_least_5_digits_long"),
        },
      ],
    }),
    [t],
  );

  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("singleRequest:recipient_information")}
        </Title>
      }
    >
      <Row className="px-1 lg:px-6" gutter={[20, 0]}>
        <Col span={24}>
          <Form.Item
            name="releasemethod"
            required
            className="font-medium"
            label={t("singleRequest:what_method_of_release")}
            rules={[
              {
                required: true,
                message: t("singleRequest:please_choose_any_option"),
              },
            ]}
          >
            <Radio.Group
              onChange={(e) => onChange(e)}
              value={singleRequestData.RecordMethod}
            >
              <Space direction="vertical" className="ms-4">
                <Radio value="email" className="font-normal">
                  {t("singleRequest:email")}
                </Radio>
                <Radio value="fax" className="font-normal">
                  {t("singleRequest:fax")}
                </Radio>
                <Radio value="mail" className="font-normal">
                  {t("singleRequest:mail")}
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Col>

        {singleRequestData.RecordMethod === "fax" ? (
          <>
            <Col xs={24} md={12}>
              <Form.Item
                className="font-medium"
                label={t("singleRequest:recipient_name_organization")}
                onChange={(e) =>
                  callparent(e.target.value, "RecordMethodReleaseName")
                }
                name="RecordMethodReleaseName"
                rules={[
                  {
                    required: true,
                    max: 50,
                    message: t(
                      "singleRequest:please_enter_recipient_name_organization",
                    ),
                  },
                ]}
              >
                <Input maxLength={50} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                className="font-medium"
                label={t("singleRequest:recipient_fax_number")}
                name="rfaxnumber"
                onChange={(e) =>
                  callparent(e.target.value, "RecordMethodReleaseFaxNumber")
                }
                rules={[
                  {
                    required: true,
                    max: 20,
                    message: t(
                      "singleRequest:please_enter_recipient_fax_number",
                    ),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </>
        ) : singleRequestData.RecordMethod === "mail" ? (
          <>
            <RequesterAddressFields
              getChildData={getChildData}
              validationRules={validationRules}
              form={form}
            />
          </>
        ) : singleRequestData.RecordMethod === "email" ? (
          <>
            <Col xs={24} md={12}>
              <Form.Item
                className="font-medium"
                label={t("singleRequest:recipient_name_organization")}
                onChange={(e) =>
                  callparent(e.target.value, "RecordMethodReleaseName")
                }
                name="RecordMethodReleaseName"
                rules={[
                  {
                    required: true,
                    max: 50,
                    message: t(
                      "singleRequest:please_enter_recipient_name_organization",
                    ),
                  },
                ]}
              >
                <Input maxLength={50} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                className="font-medium"
                label={t("singleRequest:recipient_email")}
                name="RecordMethodReleaseEmail"
                onChange={(e) =>
                  callparent(e.target.value, "RecordMethodReleaseEmail")
                }
                required
                rules={[
                  {
                    required: true,
                    max: 100,
                    message: t("singleRequest:please_enter_email"),
                  },
                  {
                    type: "email",
                    message: t("singleRequest:please_enter_valid_email"),
                  },
                ]}
              >
                <Input maxLength={100} />
              </Form.Item>
            </Col>
          </>
        ) : null}
        
        <Col span={24}>
          <Form.Item
            label={t("singleRequest:fee_contact_person")}
            required
            valuePropName="checked"
          >
            <Checkbox
              className="font-medium"
              checked={singleRequestData.useRequesterInformation}
              onChange={(e) =>
                callparent(e.target.checked, "useRequesterInformation")
              }
            >
              {t("singleRequest:use_requester_information")}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[20, 0]} className="px-1 lg:px-6">
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:name_organization")}
            onChange={(e) => callparent(e.target.value, "RecordName")}
            required
            name="rnameorganization"
            rules={[
              {
                required: true,
                max: 50,
                message: t("singleRequest:please_enter_name_organization"),
              },
            ]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:phone_number")}
            name="rphone"
            onChange={(e) => callparent(e.target.value, "RecordPhoneNumber")}
            required
            rules={[
              {
                required: true,
                max: 20,
                message: t("singleRequest:please_enter_phone_number"),
              },
              { validator: validatePhone },
            ]}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:email")}
            name="remail"
            onChange={(e) => callparent(e.target.value, "RecordEmail")}
            required
            rules={[
              {
                required: true,
                max: 100,
                message: t("singleRequest:please_enter_email"),
              },
              {
                type: "email",
                message: t("singleRequest:please_enter_valid_email"),
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="rfax"
            className="font-medium"
            label={t("singleRequest:fax_number")}
            onChange={(e) => callparent(e.target.value, "RecordFaxNumber")}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default RecordRelease;
